import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MapComponent } from '@pages/map/map.component';
import { SplitViewComponent } from '@pages/split-view/split-view.component';
import { ViewpointComponent } from '@pages/viewpoint/viewpoint.component';
import { AuthGuard } from '@shared/services/auth.guard';
import { SplashComponent } from './components/pages/splash/splash.component';

const routes: Routes = [
  // { path: '', component: SplashComponent, canActivate: [AuthGuard] },
  { path: '', component: MapComponent },
  // { path: 'map', component: MapComponent },
  { path: 'viewpoint', component: ViewpointComponent },
  // { path: 'viewpoint', component: SplitViewComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }